// extracted by mini-css-extract-plugin
export default {"indicatorContainer":"index-module__CWulE","indicatorInfo":"index-module__SGrzC","indicatorLoader":"index-module__IXFai"};